import InfoIcon from "@material-ui/icons/Info";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { IRoute } from "src/common/typings/routes";
import { Others } from "./Others";
import { RFIDPage } from "./pages/RFID";
import { WebocInfo } from "./pages/WebocInfo/index";

export const OthersRoute: IRoute = {
  title: "Others",
  path: "/others",
  icon: InsertDriveFileIcon,
  component: Others,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: WebocInfo, path: "/weboc-info", title: "WeBOC Information" },
    { icon: InfoIcon, component: RFIDPage, path: "/rfid-tags", title: "RFID Tag" },
  ],
};
